import React from 'react';

const Button = ({ children, variant = 'default', size = 'default', ...props }) => {
  const baseStyles = 'inline-flex items-center justify-center rounded-md font-medium transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-offset-2 disabled:opacity-50 disabled:pointer-events-none';
  
  const variants = {
    default: 'bg-primary text-white hover:bg-primary/90',
    ghost: 'hover:bg-gray-100 hover:text-gray-900',
  };

  const sizes = {
    default: 'h-10 py-2 px-4',
    icon: 'h-10 w-10',
  };

  const className = `${baseStyles} ${variants[variant]} ${sizes[size]}`;

  return (
    <button className={className} {...props}>
      {children}
    </button>
  );
};

export { Button }; 